import useOnResolve from '../hooks/use-on-resolve'

export default function TriggerMethodConstraintsOnResolve () {
  useOnResolve((constraints) => {
    return new Promise(resolve => {
      Object.keys(constraints).forEach(key => {
        const val = constraints[key]

        /// Values can be methods to get a LIVE value at execution time
        if (typeof val === 'function') {
          constraints[key] = val()
        }
      })

      resolve(constraints)
    })
  })

  return null
}
